import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'
import DOMPurify from 'dompurify'
import SidePanel from '../../../components/common/side-panel/SidePanel'
import MainPanel from '../../../components/common/main-panel/MainPanel'
import { triggerGoogleAnalyticsEvent } from '../../../utils/Helper'
import {
  currentUserSubscription,
  getAllSubscriptionProducts,
  userSubscriptionUsage,
} from '../../../redux/actions/SubscriptionActions'
import instance from '../../../utils/Axios'
import { toast } from 'react-toastify'
import { getCreatorMetadata } from '../../../redux/actions/CreatorMetadata'
import { Checkbox } from 'antd'

const CreatorMetadataContent = () => {
  const dispatch = useDispatch()
  const {
    auth: { user },
    creatorMetadata: { data: creatorMetadataData },
  } = useSelector((state) => state)
  const [creatorOfContent, setCreatorOfContent] = useState('')
  const [creatorOfContentMetadata, setCreatorOfContentMetadata] = useState()
  const [creatorOfContentLicense, setCreatorOfContentLicense] = useState(false)
  const [copyrightHolder, setCopyrightHolder] = useState('')
  const [copyrightHolderMetadata, setCopyrightHolderMetadata] = useState(false)
  const [copyrightHolderLicense, setCopyrightHolderLicense] = useState(false)
  const [publishingOrganization, setPublishingOrganization] = useState('')
  const [publishingOrganizationMetadata, setPublishingOrganizationMetadata] =
    useState(false)
  const [publishingOrganizationLicense, setPublishingOrganizationLicense] =
    useState(false)
  const [loading, setLoading] = useState(false)

  const submitForm = (e) => {
    e.preventDefault()
    setLoading(true)
    triggerGoogleAnalyticsEvent('save_creator_metadata', {
      userId: user?.id,
    })

    instance
      .post('/creator-metadata', {
        creatorOfContent,
        creatorOfContentMetadata,
        creatorOfContentLicense,
        copyrightHolder,
        copyrightHolderMetadata,
        copyrightHolderLicense,
        publishingOrganization,
        publishingOrganizationMetadata,
        publishingOrganizationLicense,
      })
      .then(() => {
        // setCreatorOfContent('')
        // setCreatorOfContentMetadata(false)
        // setCreatorOfContentLicense(false)
        // setCopyrightHolder('')
        // setCopyrightHolderMetadata(false)
        // setCopyrightHolderLicense(false)
        // setPublishingOrganization('')
        // setPublishingOrganizationMetadata(false)
        // setPublishingOrganizationLicense(false)
        toast.success('Creator metadata saved successfully!')
        // loadCreatorMetadata()
      })
      .catch((error) => {
        toast.error(
          error?.response?.data?.message || 'Creator metadata cannot be saved!',
        )
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const getSubscriptionUsage = async () => {
    await dispatch(userSubscriptionUsage())
  }

  const loadUserSubscription = async () => {
    await dispatch(currentUserSubscription())
  }

  const loadAllSubscriptionProducts = async () => {
    await dispatch(getAllSubscriptionProducts())
  }

  const loadCreatorMetadata = async () => {
    await dispatch(getCreatorMetadata())
  }

  useEffect(() => {
    getSubscriptionUsage()
    loadUserSubscription()
    loadAllSubscriptionProducts()
    loadCreatorMetadata()
  }, [])

  useEffect(() => {
    if (creatorMetadataData) {
      setCreatorOfContent(
        creatorMetadataData?.creatorOfContent
          ? creatorMetadataData.creatorOfContent
          : '',
      )
      setCreatorOfContentMetadata(
        creatorMetadataData?.creatorOfContentMetadata || false,
      )
      setCreatorOfContentLicense(
        creatorMetadataData?.creatorOfContentLicense || false,
      )
      setCopyrightHolder(creatorMetadataData?.copyrightHolder || '')
      setCopyrightHolderMetadata(
        creatorMetadataData?.copyrightHolderMetadata || false,
      )
      setCopyrightHolderLicense(
        creatorMetadataData?.copyrightHolderLicense || false,
      )
      setPublishingOrganization(
        creatorMetadataData?.publishingOrganization || '',
      )
      setPublishingOrganizationMetadata(
        creatorMetadataData?.publishingOrganizationMetadata || false,
      )
      setPublishingOrganizationLicense(
        creatorMetadataData?.publishingOrganizationLicense || false,
      )
    }
  }, [creatorMetadataData])

  return (
    <MainPanel>
      <div className="creator-metadata-container">
        <div className="title">
          <h2>Creator Metadata</h2>
        </div>
        <div className="creator-metadata-container__section">
          <p>
            Add and select the appropriate creator identifiers for use in the
            licensing agreement, and to add human provenance metadata to the
            asset.
          </p>

          <form onSubmit={submitForm}>
            <div className="tikbox-form-element">
              <div className="input-label">
                <label htmlFor="creatorOfContent"></label>
                <input
                  value={creatorOfContent}
                  onChange={(e) =>
                    setCreatorOfContent(DOMPurify.sanitize(e.target.value))
                  }
                  style={{ visibility: 'hidden' }}
                />
              </div>
              <div className="checkboxes">
                <p style={{ marginRight: 10, fontWeight: 500 }}>Metadata</p>
                <p style={{ fontWeight: 500 }}>License</p>
              </div>
            </div>
            <div className="tikbox-form-element">
              <div className="input-label">
                <label htmlFor="creatorOfContent">Creator of Content</label>
                <input
                  value={creatorOfContent}
                  onChange={(e) =>
                    setCreatorOfContent(DOMPurify.sanitize(e.target.value))
                  }
                  name="creatorOfContent"
                  id="creatorOfContent"
                  placeholder="Creator of content"
                />
              </div>
              <div className="checkboxes">
                <Checkbox
                  checked={creatorOfContentMetadata}
                  onChange={(e) =>
                    setCreatorOfContentMetadata(e.target.checked)
                  }
                  disabled={!creatorOfContent}
                  style={{ marginLeft: 13, marginRight: 13 }}
                  required={
                    creatorOfContent &&
                    !creatorOfContentLicense &&
                    !creatorOfContentMetadata
                  }
                  className="custom-checkbox"></Checkbox>
                <Checkbox
                  checked={creatorOfContentLicense}
                  onChange={(e) => setCreatorOfContentLicense(e.target.checked)}
                  disabled={!creatorOfContent}
                  style={{ marginLeft: 13, marginRight: 13 }}
                  required={
                    creatorOfContent &&
                    !creatorOfContentLicense &&
                    !creatorOfContentMetadata
                  }
                  className="custom-checkbox"></Checkbox>
              </div>
            </div>
            <div className="tikbox-form-element">
              <div className="input-label">
                <label htmlFor="copyrightHolder">Copyright Holder</label>
                <input
                  value={copyrightHolder}
                  onChange={(e) =>
                    setCopyrightHolder(DOMPurify.sanitize(e.target.value))
                  }
                  name="copyrightHolder"
                  id="copyrightHolder"
                  placeholder="Copyright holder"
                />
              </div>
              <div className="checkboxes">
                <Checkbox
                  checked={copyrightHolderMetadata}
                  onChange={(e) => setCopyrightHolderMetadata(e.target.checked)}
                  disabled={!copyrightHolder}
                  style={{ marginLeft: 13, marginRight: 13 }}
                  required={
                    copyrightHolder &&
                    !copyrightHolderLicense &&
                    !copyrightHolderMetadata
                  }
                  className="custom-checkbox"></Checkbox>
                <Checkbox
                  checked={copyrightHolderLicense}
                  onChange={(e) => setCopyrightHolderLicense(e.target.checked)}
                  disabled={!copyrightHolder}
                  style={{ marginLeft: 13, marginRight: 13 }}
                  required={
                    copyrightHolder &&
                    !copyrightHolderLicense &&
                    !copyrightHolderMetadata
                  }
                  className="custom-checkbox"></Checkbox>
              </div>
            </div>
            <div className="tikbox-form-element">
              <div className="input-label">
                <label htmlFor="publishingOrganization">
                  Publishing Organization
                </label>
                <input
                  value={publishingOrganization}
                  onChange={(e) =>
                    setPublishingOrganization(
                      DOMPurify.sanitize(e.target.value),
                    )
                  }
                  name="publishingOrganization"
                  id="publishingOrganization"
                  placeholder="Publishing organization"
                />
              </div>
              <div className="checkboxes">
                <Checkbox
                  checked={publishingOrganizationMetadata}
                  onChange={(e) =>
                    setPublishingOrganizationMetadata(e.target.checked)
                  }
                  disabled={!publishingOrganization}
                  style={{ marginLeft: 13, marginRight: 13 }}
                  required={
                    publishingOrganization &&
                    !publishingOrganizationLicense &&
                    !publishingOrganizationMetadata
                  }
                  className="custom-checkbox"></Checkbox>
                <Checkbox
                  checked={publishingOrganizationLicense}
                  onChange={(e) =>
                    setPublishingOrganizationLicense(e.target.checked)
                  }
                  disabled={!publishingOrganization}
                  style={{ marginLeft: 13, marginRight: 13 }}
                  required={
                    publishingOrganization &&
                    !publishingOrganizationLicense &&
                    !publishingOrganizationMetadata
                  }
                  className="custom-checkbox"></Checkbox>
              </div>
            </div>
            <div className="tikbox-form-element">
              <button disabled={loading} type="submit">
                {loading ? 'Saving...' : 'Save'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </MainPanel>
  )
}

const CreatorMetadata = () => {
  return (
    <div className="tikbox-creator-metadata">
      <div className="tikbox-creator-metadata__content">
        <SidePanel />
        <CreatorMetadataContent />
      </div>
    </div>
  )
}

export default CreatorMetadata
